import { Routes } from '@angular/router';
import { LandingComponent } from './components/landing/landing.component';
import { SignInComponent } from './components/auth/sign-in/sign-in.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MeterDetailsComponent } from './components/meter-details/meter-details.component';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';
import { AboutComponent } from './components/about/about.component';
import { authGuard, rootGuard } from './guards/auth.guard';
import { AuthComponent } from './components/auth/auth/auth.component';
import { Component } from '@angular/core';
import { SdkAuthComponent } from './components/auth/auth/sdk-auth.component';
import { DeveloperGuideComponent } from './components/developer-guide/developer-guide.component';
import { DeveloperGuideApiComponent } from './components/developer-guide-api/developer-guide-api.component';
import { SdkHandleConsentComponent } from './components/sdk/sdk-handle-consent/sdk-handle-consent.component';
import { SdkResultComponent } from './components/sdk-result/sdk-result.component';
import { SignatureCompleteComponent } from './components/signature-complete/signature-complete.component';


// This component is only a placeholder. The redirection logic is handled by the rootGuard.
@Component({
  selector: 'app-root-redirect',
  template: '',
  styles: []
})
export class AppRouteRedirectComponent { 
  constructor() {
    // This component is used to redirect the root path
  }
}

export const routes: Routes = [
  { path: 'signin', component: SignInComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'auth', component: AuthComponent },
  { path: 'sdk-auth', component: SdkAuthComponent }, // Assuming SdkAuthComponent is imported
  { path: 'landing', component: LandingComponent },
  { path: 'dev-guide', component: DeveloperGuideComponent },
  { path: 'dev-guide-api', component: DeveloperGuideApiComponent },
  { path: 'sdk-handle-consent', component: SdkHandleConsentComponent, canActivate: [] },
  // Full-page SDK result view (protected), intentionally outside of LayoutComponent
  { path: 'sdk-result', component: SdkResultComponent, canActivate: [authGuard] },
  // Oneflow redirects here after digital signature completion
  { path: 'signature-complete', component: SignatureCompleteComponent },

  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: AppRouteRedirectComponent, canActivate: [rootGuard] },
      { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
      { path: 'meter-details', component: MeterDetailsComponent, canActivate: [authGuard] },

      { path: 'profile', component: ProfilePageComponent, canActivate: [authGuard] },
      { path: 'about', component: AboutComponent, canActivate: [authGuard] },
      // Add a wildcard route within the authenticated area
      { path: '**', redirectTo: 'landing' }
    ]
  },
  // Add a global wildcard route for completely unmatched paths
  { path: '**', redirectTo: 'landing' } // or create a 404 component
];
